import { Buttons, Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { TAX_YEAR } from 'Config';
import * as Styled from './styles';

const CompensationBox = ({
  resultInfo,
  compensation,
  handleCompensation,
  handleNotCompensation,
}: {
  resultInfo: number;
  compensation: boolean;
  handleCompensation: () => void;
  handleNotCompensation: () => void;
}): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  return (
    <Styled.CompensationBoxContainer
      justify="center"
      align="center"
      direction="column"
      gap="dimension_08"
      $compensation={compensation}
    >
      {compensation && (
        <Styled.CloseButton
          icon="CrossXXS"
          mode="primary"
          size="xs"
          onClick={handleNotCompensation}
        />
      )}
      <Text type="paragraphs" color={compensation ? 'dark' : 'grey'} size="S_M_S">
        {TAX_YEAR}
      </Text>
      {compensation ? (
        <Text type="paragraphs" color="cold" size="S_L_S">
          {`-${YayoyakiFormatter.formatAmountMxn(Math.abs(resultInfo))}`}
        </Text>
      ) : (
        <Buttons.Tiny onClick={handleCompensation} label={t('Compensation.tiny.button')} />
      )}
    </Styled.CompensationBoxContainer>
  );
};

export default CompensationBox;
